import React, { useState } from 'react'
import { Input, Radio, Tooltip, Space } from 'antd';

const { TextArea } = Input;

export default function TrueOrFalse(props) {
   const handleChange = (value) => {
      props.parentCallback("update", value, props.id);
   }

   const handleCheckChange = (event) => {
      props.parentCallback("update-check-radio", event.target.checked, props.id);
   }

   return (
      <>
         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '7px' }}>
            <Radio
               name={props.cardid + "-true"}
               checked={props.correct === "1" ? true : false}
               onChange={handleCheckChange}
               disabled={props.mode.includes("assign") || props.mode.includes("view") ? true : false}
            />
            <TextArea
               autoSize={{
                  minRows: 1,
                  maxRows: 2,
               }}
               id={props.id}
               name={props.id}
               defaultValue={props.value}
               onBlur={(e) => handleChange(e.target.value)}
               allowClear
               disabled={props.mode === "answer" || props.mode.includes("assign") || props.mode.includes("view") ? true : false}
               placeholder={props.mode === "answer" || props.mode.includes("assign") || props.mode.includes("view") ? 'Borderless' : ''}
               style={{ borderRadius: 7, width: "100%", marginRight: '7px', fontSize: '16px' }}
            />
         </div>
      </>
   )
}